import React from 'react';
import { motion } from 'framer-motion';

const Philosophy = () => {
  const values = [
    {
      title: 'Service',
      description: 'Rooted in the ancient science of energy healing for body, mind, and soul.',
    },
    {
      title: 'Integrity',
      description: 'Customized solutions delivered with consistent professionalism and confidentiality.',
    },
    {
      title: 'Compassion',
      description: "A deep respect for each individual's journey toward resilience and clarity.",
    },
  ];

  return (
    <section id="philosophy" className="scroll-mt-24 px-6 py-20 lg:px-8 lg:py-28">
      <motion.div 
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-60px' }}
        transition={{ duration: 0.8 }}
        className="mx-auto max-w-4xl text-center"
      >
        <span className="mb-4 block text-xs font-medium uppercase tracking-[0.3em] text-lotus-deep/80">
          Our Philosophy
        </span>
        <h2 className="font-serif text-3xl leading-tight text-lotus-ink sm:text-4xl lg:text-5xl">
          True wellness extends beyond the absence of illness
        </h2>
        <p className="mt-6 text-lg leading-relaxed text-lotus-ink/70">
          It is about cultivating inner peace, emotional stability, mental clarity, and harmonious relationships with ourselves and those around us. Our philosophy is rooted in service, integrity, compassion, and continuous growth, helping people live with greater awareness and purpose.
        </p>

        <div className="mt-16 grid gap-10 border-t border-lotus-petal pt-16 text-left md:grid-cols-3">
          {values.map((item, idx) => (
            <motion.div 
              key={item.title} 
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-40px' }}
              transition={{ duration: 0.6, delay: idx * 0.15 }}
              whileHover={{ y: -4 }}
              className="group cursor-default p-4 rounded-2xl transition-all duration-300 hover:bg-white hover:shadow-sm border border-transparent hover:border-lotus-petal/50"
            >
              <h3 className="font-serif text-xl text-lotus-ink group-hover:text-lotus-deep transition-colors">
                {item.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-lotus-ink/60">
                {item.description}
              </p>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </section>
  );
};

export default Philosophy;
